import { render, staticRenderFns } from "./FormDocumentTypeLocale.vue?vue&type=template&id=1eb6aba2&scoped=true&"
import script from "./FormDocumentTypeLocale.vue?vue&type=script&lang=js&"
export * from "./FormDocumentTypeLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb6aba2",
  null
  
)

export default component.exports